<template>
<div id="transferManage">
  <div class="search" style="margin-top:30px;">
    <h2 style="font-size:18px;">已创建的任务</h2>
  </div>
  <div class="contentView">
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column
        prop="taskName"
        label="任务名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="taskType"
        label="客户类型"
        min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.taskType == 0">双签</span>
          <span v-if="scope.row.taskType == 1">注册</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountService"
        label="客服数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="callNums"
        label="已呼叫数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="amountClient"
        label="客户数量"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="throughNums"
        label="接通数量"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        min-width="120">
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmit(scope.row)">查看</span>
          <span class="to_able" @click="closeBtn(scope.row)">取消</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      searchParams: {
        mobile: '',
        Name: '',
        isAccount: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      tableData: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      dialog: {
        submit: {
          show: false,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      }
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList () {
      this.axios.get('/doubleTask/pagetaskList' + devCode, {
        params: {
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        console.log(res);
        if (res.data.isSuccess) {
          this.tableData = res.data.resultData.pageListData;
          this.totalResult = res.data.resultData.totalResult;
          this.totalPage = res.data.resultData.totalPage;
        };
      });
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 搜索列表
    submitSearch1 () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 打开提交审核
    openSubmit (obj) {
      console.log(obj);
      this.$router.push({
        name: 'taskDetail',
        query: {
          taskId: obj.id,
          amountService: obj.amountService,
          connectNum: obj.throughNums, // 接通数量
          callNums: obj.callNums, // 已呼叫数
          clientNum: obj.amountClient // 客户数量
        }
      });
      // this.$router.push({name: 'taskDetail'});
    },
    // 取消
    closeBtn (obj) {
      this.axios({
        url: `/doubleTask/updateTask` + devCode,
        method: 'post',
        data: {
          id: obj.id,
          taskStatus: 1
        }
      }).then(res => {
        if (res.data.isSuccess) {
          this.$message.success(res.data.message);
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
</style>



// WEBPACK FOOTER //
// src/components/taskManage/isTruetask.vue